export default __webpack_public_path__ + "static/media/catalogue_cart_representation.a0a40e5d.svg";